module.exports = __webpack_public_path__ + "static/media/2015_conf_Product_Strategy_Product_Success.aae7215b.png";